import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import {Router} from '@angular/router';
import { NSApiService } from '../../../service/NSApi.service';
import { NSHelperService } from '../../../service/NSHelper.service';
import { TranslateService } from '@ngx-translate/core';
import { SettingsManagementService } from 'projects/fe-common/src/lib/services/settings-management.service';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../../service/api.service';
import { HelperService } from '../../../service/helper.service';
import {Subject} from "rxjs";
import { EncryptionService } from '../../../service/encryption.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  toggleIcon='assets/images/toggle-icon.svg';
  profileIMG='';
  public config: any = {};
  panelOpenState = false;
  loginUserData: any = {};
  loginIncidentsData: any = {};
  sideListMenuName: string = 'Dashboard';

  logoId:any;
  profileDetails:any;
  firstName:string;
  lastName:string;
  englishFlag = './assets/images/english.png';
  italianFlag = './assets/images/italian.png';
  downArrow = './assets/images/down-arrow.svg';
  flagEng = './assets/images/flag-eng.png';
  loginUser: boolean = true;
  userLanguageSelect: string;
  lanuageData: any = null;
  lanuageName: any = null;
  getSupplierAgreement: any = {};
  private destroy$ = new Subject();
  CustomerName:any;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private helper: NSHelperService,
    private APIservice: NSApiService,
    public translate: TranslateService,
    private settingManager: SettingsManagementService,
    private Api: ApiService,
    private languagehelper: HelperService,
    private encryptionService: EncryptionService,
    private Api_Service: ApiService,
  
  ) {

    this.languagehelper.sideMenuListName.subscribe((name: any) => {
      this.sideListMenuName = name;
      // this.sideListMenuName = this.translate.instant(name);
    });
    this.helper.profileFirstName.subscribe((namefirst:any)=>{
      this.firstName = namefirst;
    });
    this.helper.profileLastName.subscribe((nameLast:any)=>{
      this.lastName = nameLast
    });
   }

  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }

  ngOnInit(): void {
    // document.body.classList.add('application-dropdown')
    this.userLanguageSelect = HelperService.getLanguageName();
    if (!this.userLanguageSelect) {
        this.translate.use('it');
        this.settingManager.setSettingsValue('currentLanguage', 'it');
    } else {
        this.translate.use(this.userLanguageSelect);
        this.settingManager.setSettingsValue('currentLanguage', this.userLanguageSelect);
    }
    this.loginUser = (HelperService.loginUserToken) ? false : true;
    this.helper.loaderVisibilityChange.subscribe((value) => {
    });
    this.userLanguageSelect = this.settingManager.getSettingsValue('currentLanguage');
    const loginUser = this.encryptionService.getDataFromLocalStorage('NPLoginId');
    this.getDetails(JSON.parse(loginUser))
    
}


getDetails(userId) {
  this.Api_Service.getCustomerDetails(userId).subscribe((res: any) => {
    if (res.result && res.data) {
      const getRequestData = res.data;
      this.CustomerName = getRequestData.companyName;
      this.helper.toggleLoaderVisibility(false);
    } 
  });

}

openMenuBox() {
    document.body.classList.add('openMenuBox')
}

closeMenuBox() {
    document.body.classList.remove('openMenuBox')
}

onLanguageChange(valueLanguage: any) {
    this.languagehelper.languageTranslator(valueLanguage.value);
    this.translate.use(valueLanguage.value);
    this.document.documentElement.lang = valueLanguage.value;
    this.settingManager.setSettingsValue('currentLanguage', valueLanguage.value);
}

redirectPage() {
}

logout(): void {
    this.Api.logout().subscribe((res: any) => {});
    document.body.classList.remove('openMenuBox');
    HelperService.onLogOut();
    this.router.navigate(['']);
}

ngOnDestroy() {
    document.body.classList.remove('application-dropdown');
}

  firstChangeImageFunction(){
    const NSLoggedInUser = JSON.parse(localStorage.getItem('NSLoggedInUser'))
    this.APIservice.editViewProfile(NSLoggedInUser.id).subscribe((data:any)=>{
      this.firstName = data.data.first_name;
      this.lastName = data.data.last_name;
      this.logoId = data.data.profile_id;
      if(this.logoId){
        this.APIservice.editViewProfileImg(this.logoId).subscribe((data:any)=>{
          this.profileIMG = data.data;
        });
      }
    });
  }

  logOUT() {
    NSHelperService.onLogOut();
    this.router.navigate(['/']);
  }

  sideMenuName(){
    this.sideListMenuName = 'Settings';
  }

}
